import { getSavedConfiguration } from '../requests/getSharing';
import { requestConfigurationCode, requestShortLinkCode } from '../requests/postSharing';
// QueryParams used to be used to 'hard-code' links initially.
// TODO: Remove when (or if) we switch all our sharing to use our ShortLinkServices.
// TODO: Don't forget to implement QR -> AR links via `fromQrLink` QueryParam. If using ShortLinkServices, this data should be added into Hyrule as valid information.
export var QueryParam;
(function (QueryParam) {
    QueryParam["LaunchIntent"] = "launchIntent";
    QueryParam["LaunchProductId"] = "launchProductId";
})(QueryParam || (QueryParam = {}));
// <!-- Internal -->
// Generate Short Link
const buildShortLink = async (linkTo, baseRedirectUrl, data, serviceUrls) => {
    const shortLinkData = {
        type: linkTo,
        baseRedirectUrl,
        data,
    };
    const getShortLinkCode = await requestShortLinkCode(serviceUrls, shortLinkData);
    return `${serviceUrls.links.frontend?.split('/api')[0]}/${getShortLinkCode.data.linkId}`;
};
// <!-- Exported -->
// TODO: Replace with short link solution once hyrule changes go live
export const buildInspirationLink = async (baseRedirectUrl, launchProductId, serviceUrls) => {
    const shortLinkResponse = await buildShortLink('explore', baseRedirectUrl, { productId: launchProductId }, serviceUrls);
    return shortLinkResponse;
};
export const buildConfigurationLink = async (linkTo, baseRedirectUrl, postData, serviceUrls) => {
    const getConfigurationCode = await requestConfigurationCode(serviceUrls, postData);
    const shortLinkResponse = await buildShortLink(linkTo, baseRedirectUrl, getConfigurationCode.data, serviceUrls);
    return shortLinkResponse;
};
export const getSavedConfigurationById = async (sharedConfiguratorId, serviceUrls) => {
    const savedConfiguration = await getSavedConfiguration(serviceUrls, sharedConfiguratorId);
    return {
        configurationSpaceId: savedConfiguration.data.configuratorId,
        currentSelections: savedConfiguration.data.selections.properties,
        attachments: savedConfiguration.data.selections.attachments,
    };
};
const omit = (obj, ...keys) => Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
export const extractSavedModularConfiguration = (savedConfiguration) => {
    const globalSelectionKeys = ['fabric', 'feet', 'cushion'];
    const piecesFromSave = Object.values(
    // TODO re-parse properly
    omit(savedConfiguration.currentSelections, ...globalSelectionKeys));
    const selectionsFromSave = Object.fromEntries(Object.entries(savedConfiguration.currentSelections).filter(([k, _]) => globalSelectionKeys.includes(k)));
    return {
        modularConfiguratorId: savedConfiguration.configurationSpaceId,
        pieces: piecesFromSave,
        globalSelections: selectionsFromSave,
    };
};
